import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

/**
* Safely formats a date/time value using dayjs.
*
* - Returns "-" if the input is null, undefined, or invalid.
* - Prevents runtime crashes due to bad date values.
* - Accepts a custom format string (default: "DD MMM YYYY, hh:mm A").
*
* @param {string | number | Date} date - The date value to format
* @param {string} format - Optional dayjs format string
* @returns {string} Formatted date or "-" fallback
*/
export const formatDateTime = (date, format = "DD MMM YYYY, hh:mm A") => {
    try {
        if (!date) return "-";

          const parsed = dayjs.utc(date); // UTC

        if (!parsed.isValid()) return "-";

        return parsed.format(format);
    } catch (err) {
        console.error("Date format error:", err);
        return "-";
    }
};